"use strict";


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch-core/dist/cjs/types/translatable.js
// module id = 1061
// module chunks = 142807904292071